// src/components/elements/LearnMoreLink.js
import React, { useState } from 'react';
import TermsModal from '../modals/TermsModal';

const LearnMoreLink = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const openTermsModal = () => setIsTermsOpen(true);
  const closeTermsModal = () => setIsTermsOpen(false);

  return (
    <>
      <button
        onClick={openTermsModal}
        className="ml-1 underline underline-offset-4 text-gray-400 hover:text-gray-600"
      >
        Terms & Privacy
      </button>
      <TermsModal isOpen={isTermsOpen} onClose={closeTermsModal} />
    </>
  );
};

export default LearnMoreLink;
